document.addEventListener('DOMContentLoaded', () => {

  const MOBILE_BREAKPOINT = 767;

  function initUniversalGrid() {

    const sections = document.querySelectorAll(
      '.section-universal-grid .universal-grid.universal-grid--mobile-slider'
    );

    sections.forEach(grid => {

      const wrapper = grid.querySelector('.universal-grid--wrapper');
      if (!wrapper) return;

      const existingScroller = wrapper.querySelector(
        ':scope > .universal-grid--mobile-media-scroller'
      );

      const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

      /* ---------------------------
         MOBILE MODE
      ----------------------------*/

      if (isMobile && !existingScroller) {

        const items = Array.from(wrapper.children)
          .filter(el => el.classList.contains('universal-grid--item'));

        const mediaItems = items.filter(el =>
          el.classList.contains('type-image') ||
          el.classList.contains('type-video')
        );

        if (!mediaItems.length) return;

        const scroller = document.createElement('div');
        scroller.className = 'universal-grid--mobile-media-scroller';

        mediaItems.forEach(item => scroller.appendChild(item));

        wrapper.insertBefore(scroller, wrapper.firstChild);
      }

      /* ---------------------------
         DESKTOP MODE
      ----------------------------*/

      if (!isMobile && existingScroller) {

        const mediaItems = Array.from(existingScroller.children);

        mediaItems.forEach(item => {
          wrapper.insertBefore(item, existingScroller);
        });

        existingScroller.remove();
      }

    });
  }

  /* Run once */
  initUniversalGrid();

  /* Re-run on resize */
  let resizeTimer;
  window.addEventListener('resize', () => {

    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      initUniversalGrid();
    }, 150);

  });

});